import strings from '../../../localization';
import { withSnackbar } from 'notistack';
import * as Actions from "../../../actions/Actions";
import { withRouter } from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import { bindActionCreators } from "redux";
import SpecificationReportPage from './SpecificationReportPage';
import { generateTransporterSummaryReport } from '../../../services/report/ReportService';

class TransporterSummaryReport extends SpecificationReportPage {

  getFields() {
    return ['graveyard', 'period'];
  }

  getService() {
    return generateTransporterSummaryReport;
  }

  getFileName() {
    return "2C-gks-transporteri";
  }

  getPageTitle() {
    return strings.specificationReports.transporterSummaryTitle;
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    changeFullScreen: Actions.changeFullScreen
  }, dispatch);
}

function mapStateToProps({ menuReducers, authReducers, siteDataReducers }) {
  return { menu: menuReducers, auth: authReducers, siteData: siteDataReducers };
}

export default withSnackbar(withRouter(connect(mapStateToProps, mapDispatchToProps)(TransporterSummaryReport)));
